import { createFeature, createReducer, on } from '@ngrx/store';
import { EcddModel } from '@shared/data-access/models';
import { EcddAction } from '../actions';

export const featureName = 'ecdd';

export interface EcddState {
  item: EcddModel | null;
  draftItem: EcddModel;
}

export const initialState: EcddState = {
  item: null,
  draftItem: EcddModel.createEmpty(),
};

export const ecddFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(EcddAction.setItemDetail, (state, { item }) => ({
      ...state,
      item,
    })),
  ),
});

export const { name, reducer } = ecddFeature;
